import debounce from "../helpers/debounce";

class Header {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        const scrollDebounce = debounce(function () {
            if(window.scrollY > 50) {
                self.elem.classList.add('is-shrunk');
            } else {
                self.elem.classList.remove('is-shrunk');
            }
        });

        window.addEventListener('scroll', function () {
            scrollDebounce();
        }, false);
    }
}

export default Header;
